import styles from 'styles/modules/Experts.module.scss';
import Avatar from './Svg/Avatar.js';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import Typo from './Typo';

const Expert = (props) => {
    const { isAuthorized } = useSelector(authSelector);
    const { item, key } = props.data;
    const { onClick, onElementClick, expertToRemoveFake } = props;

    const handleOnClick = (item) => {
        if (onClick) {
            onClick(item);
        }
    };

    const handleProfile = (item) => {
        if (onElementClick) {
            onElementClick(item);
        }
    };
    if (expertToRemoveFake && expertToRemoveFake.id === item.id) return null;

    return (
        <div className={styles.expert} key={`expert-${key}`}>
            <div className={styles.image} onClick={() => handleProfile(item)}>
                {item.image ? <img src={item.image.path} /> : <Avatar />}
            </div>
            <div className={styles.body} onClick={() => handleProfile(item)}>
                <Typo variant={'caption'}>{item.name}</Typo>
                <Typo variant={'small'}>{item.position}</Typo>
            </div>
            {isAuthorized && (
                <button
                    className={styles.remove}
                    onClick={() => handleOnClick(item)}
                >
                    Remove
                </button>
            )}
        </div>
    );
};

export default Expert;
